// React
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
// Components
import RtInfoCardSupportChat from './RtInfoCardSupportChat'
// External
import { get } from 'lodash'

const mapStateToProps = (
  { orderDetailDialogReducer: { orderId }, ordersReducer: { orders } },
  { intl: { formatMessage } },
) => {
  const order = orders.find(order => order.id === +orderId)
  const orderDetail =
    order && order.detail
      ? order.detail
      : {
          id: orderId,
          products: {},
        }
  const storeKeeperId = get(orderDetail, 'storekeeper.id', 0)
  const storeKeeperName = get(orderDetail, 'storekeeper.first_name', '')
  const storeKeeperPhone = get(orderDetail, 'storekeeper.phone', 0)
  const storeKeeperLastName = get(orderDetail, 'storekeeper.last_name', '')
  const storeKeeperPhoto = get(orderDetail, 'storekeeper.profile_pic', '')
  return {
    orderDetail,
    storeKeeperId,
    storeKeeperName,
    storeKeeperPhone,
    storeKeeperLastName,
    storeKeeperPhoto,
  }
}
const mapDispatchToProps = {}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RtInfoCardSupportChat),
)
